<app-img-header
  [title]="isViewMode ? 'Ver Plan Piso' : (isEditMode ? 'Editar Plan Piso' : 'Nuevo Plan Piso')"
  hasSubTitle="true"
  [subTitle]="getSubTitle()"
  alt="Plan Piso"
  image="/assets/images/catalogos/intro.jpg"
>
</app-img-header>

<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>

<main class="main" id="planPisoEdit">
  <div id="detail">
    <div class="pageWidth">
      <form [formGroup]="wholesaleForm" (ngSubmit)="onSubmit()">
        <div id="wholesale">
          <h3>Información del Plan Piso</h3>

          <div class="wrapperG4">
            <div class="controlWrapper nombre">
              <label>Nombre<span class="required">*</span></label>
              @if(isViewMode) {
                <span class="readOnly">{{ wholesaleForm.get('name')?.value || '-' }}</span>
              } @else {
                <input type="text" formControlName="name" />
                <div *ngIf="wholesaleForm.get('name')?.touched && wholesaleForm.get('name')?.invalid" class="error">
                  <small *ngIf="wholesaleForm.get('name')?.hasError('required')">El nombre es obligatorio.</small>
                  <small *ngIf="wholesaleForm.get('name')?.hasError('maxlength')">El nombre no puede exceder 255 caracteres.</small>
                </div>
              }
            </div>

            <div class="controlWrapper">
              <label>Distribuidor</label>
              @if(isViewMode) {
                <span class="readOnly">{{ getDealerName(wholesaleForm.get('dealerId')?.value) || 'Sin asignar' }}</span>
              } @else {
                <app-select
                  [options]="dealerOptions"
                  [placeholder]="'Seleccione un distribuidor (opcional)'"
                  [defaultValue]="getSelectedDealerOption()"
                  (optionSelected)="onDealerChange($event)"
                ></app-select>
              }
            </div>
            <div class="controlWrapper">
              <label>Sucursales</label>
              @if(isViewMode) {
                <span class="readOnly">{{ dealerBranchNames || 'Sin asignar' }}</span>
              } @else {
                <app-taggable-multi-select
                  [label]="''"
                  [placeholder]="'Seleccione sucursales (opcional)'"
                  [options]="branchOptions"
                  [displayKey]="'name'"
                  [selectedValues]="getSelectedBranchValues()"
                  (selectionChange)="onBranchesChange($event)"
                ></app-taggable-multi-select>
              }
            </div>

            <div class="controlWrapper">
              <label>Clave Plan Piso MXN<span class="required">*</span></label>
              @if(isViewMode) {
                <span class="readOnly">{{ wholesaleForm.get('wholeSaleKeyMxn')?.value || '-' }}</span>
              } @else {
                <input type="text" formControlName="wholeSaleKeyMxn" />
                <div *ngIf="wholesaleForm.get('wholeSaleKeyMxn')?.touched && wholesaleForm.get('wholeSaleKeyMxn')?.invalid" class="error">
                  <small *ngIf="wholesaleForm.get('wholeSaleKeyMxn')?.hasError('required')">La clave MXN es obligatoria.</small>
                  <small *ngIf="wholesaleForm.get('wholeSaleKeyMxn')?.hasError('pattern')">El formato debe ser MP, PL o 77 seguido de 3 números (ejemplo: MP000).</small>
                </div>
              }
            </div>

            <div class="controlWrapper">
              <label>Clave Plan Piso USD</label>
              @if(isViewMode) {
                <span class="readOnly">{{ wholesaleForm.get('wholeSaleKeyUsd')?.value || '-' }}</span>
              } @else {
                <input type="text" formControlName="wholeSaleKeyUsd" />
                <div *ngIf="wholesaleForm.get('wholeSaleKeyUsd')?.touched && wholesaleForm.get('wholeSaleKeyUsd')?.invalid" class="error">
                  <small *ngIf="wholesaleForm.get('wholeSaleKeyUsd')?.hasError('pattern')">El formato debe ser ML o 77 seguido de 3 números (ejemplo: ML000).</small>
                </div>
              }
            </div>

            <div class="controlWrapper">
              <label>Activo<span class="required">*</span></label>
              @if(isViewMode) {
                <span class="readOnly">{{ wholesaleForm.get('active')?.value === 1 ? 'Activo' : 'Inactivo' }}</span>
              } @else {
                <app-select
                  [options]="activeOptions"
                  [placeholder]="'Seleccione un estado'"
                  [defaultValue]="getSelectedActiveOption()"
                  (optionSelected)="onActiveChange($event)"
                ></app-select>
                <div *ngIf="wholesaleForm.get('active')?.touched && wholesaleForm.get('active')?.invalid" class="error">
                  <small *ngIf="wholesaleForm.get('active')?.hasError('required')">El estado es obligatorio.</small>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="generalActions">
          @if(isViewMode) {
            <button type="button" class="secondary" (click)="goBack()">Volver</button>
            <button type="button" class="primary" (click)="goToEdit()">Editar</button>
          } @else {
            <button type="button" class="secondary" (click)="cancel()">Cancelar</button>
            <button type="submit" class="primary" [disabled]="wholesaleForm.invalid || isLoading">
              {{ isEditMode ? 'Actualizar' : 'Guardar' }}
            </button>
          }
        </div>
      </form>
    </div>
  </div>
</main>
